<template>
  <div class="home-page">
    <div class="brand-block">
      <img :src="logoUrl" alt="欧小橙" class="page-logo" />
      <h2 class="page-title">欧小橙代拍一站式web管理平台</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      logoUrl: require('@/static/logo.png')
    }
  }
}
</script>

<style scoped lang="scss">
.home-page {
  text-align: center;
  padding: 40px 0;
}
.brand-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
.page-logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
}
.page-title {
  margin: 0;
  color: #FF8C00;
  font-size: 28px;
}
</style>
